<template>
  <div id="catalogEdit" :class="{ readonly: !$store.getters.loggedUserCanModifyInventory }">
    <div class="container">

      <Tabs>
        <Panel :title="`Service ${data.type}`">
          <Draggable v-model="categorySelections" :options="{ group: 'categories' }" @start="drag = true"
            @end="drag = false">
            <Panel v-for="categorySelect in categorySelections" v-if="ready"
              :title="getCategoryName(categorySelect.catId)" :key="categorySelect.catId" collapsible collapsed>
              <Draggable v-model="categorySelect.items" :options="{ group: `cat_${categorySelect.catId}}` }"
                @start="drag = true" @end="drag = false">
                <div v-for="select in categorySelect.items" class="item-checkbox-line">
                  <input :id="`chk_${select.id}`" type="checkbox" :value="select.id" v-model="data.selected">
                  <label :for="`chk_${select.id}`">{{ getItemName(select.itemId) }}</label>
                </div>
              </Draggable>
            </Panel>
          </Draggable>
        </Panel>
      </Tabs>

      <div class="footer-actions" v-if="$store.getters.loggedUserCanModifyInventory">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { Core } from "@/core/Core";
  import Draggable from 'vuedraggable';

  export default {
    name: "catalogEdit",

    components: { Draggable },

    data() {
      return {
        ready: false,
        inventory: null,
        items: {},
        categories: {},
        categorySelections: [{
          catId: null,
          items: [{
            id: null,
            itemId: null
          }]
        }],
        data: {
          id: null,
          type: "",
          selected: [],
          itemPriorities: {},
          categoryPriorities: {}
        }
      }
    },

    async mounted() {
      let catalogId = this.$route.query.id;
      this.inventory = await this.$store.getters.getContextInventory;

      this.$store.commit('showSpinner', true);
      Promise
        .all([
          catalogId ? Core.request("GET", `/api/inventory/${this.inventory.id}/catalogs/${catalogId}`) : Promise.resolve(),
          Core.request("GET", `/api/inventory/${this.inventory.id}/categories`),
          Core.request("GET", `/api/inventory/${this.inventory.id}/items`),
          Core.request("GET", `/api/inventory/${this.inventory.id}/item_to_categories`)
        ])
        .then(([catalog, categories, items, itemToCategories]) => {
          if (catalogId) {
            this.data.id = catalog.id;
            this.data.type = catalog.type;
            this.data.selected = catalog.selected;
            this.data.itemPriorities = catalog.itemPriorities;
            this.data.categoryPriorities = catalog.categoryPriorities
          }

          for (let c of categories) {
            this.categories[c.id] = c
          }
          for (let i of items) {
            this.items[i.id] = i;
          }

          this.categorySelections = categories
            .sort((cat1, cat2) => {
              if (this.data.categoryPriorities[cat1.id] && this.data.categoryPriorities[cat2.id]) {
                return this.data.categoryPriorities[cat1.id] < this.data.categoryPriorities[cat2.id] ? -1 : 1;
              } else if (this.data.categoryPriorities[cat1.id]) {
                return -1
              } else if (this.data.categoryPriorities[cat2.id]) {
                return 1;
              } else {
                return cat1.priority < cat2.priority ? -1 : 1
              }
            })
            .map(category => ({
              catId: category.id,
              items: itemToCategories
                .filter(itc => itc.category === category.id && !this.isItemDeleted(itc.item))
                .sort((itc1, itc2) => {
                  if (this.data.itemPriorities[itc1.id] && this.data.itemPriorities[itc2.id]) {
                    return this.data.itemPriorities[itc1.id] < this.data.itemPriorities[itc2.id] ? -1 : 1;
                  } else if (this.data.itemPriorities[itc1.id]) {
                    return -1
                  } else if (this.data.itemPriorities[itc2.id]) {
                    return 1;
                  } else {
                    return itc1.priority < itc2.priority ? -1 : 1
                  }
                })
                .map(itc => ({
                  id: itc.id,
                  itemId: itc.item
                }))
            }));

          this.ready = true
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);

          if (this.$store.getters.isBranchContextInventory) {
            window.lockFields(this.$store.getters.getOverloadableFields);
          } else if (!this.$store.getters.loggedUserCanModifyInventory) {
            window.lockFields();
          }
        });
    },

    methods: {

      isItemDeleted(id) {
        return !this.items[id];
      },

      getItemName(id) {
        return this.$to(this.items[id].name);
      },

      getCategoryName(id) {
        return this.$to(this.categories[id].name);
      },

      save() {
        let method = this.data.id ? "PUT" : "POST";
        let url = this.data.id
          ? `/api/inventory/${this.inventory.id}/catalogs/${this.data.id}`
          : `/api/inventory/${this.inventory.id}/catalogs`;

        let i = 1;
        let itemPriorities = {};
        for (let catSelection of this.categorySelections) {
          for (let itemSelect of catSelection.items) {
            itemPriorities[itemSelect.id] = i;
            i++
          }
        }
        this.data.itemPriorities = itemPriorities;

        let j = 1;
        let categoryPriorities = {};
        for (let catSelection of this.categorySelections) {
          categoryPriorities[catSelection.catId] = j;
          j++
        }
        this.data.categoryPriorities = categoryPriorities;

        this.$store.commit('showSpinner', true);
        Core.request(method, url, this.data)
          .then(x => {
            this.data.id = x.id;
          })
          .finally(() => {
            this.$store.commit('showSpinner', false);
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-checkbox-line {
    margin-left: 30px;

    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }

  .readonly .item-checkbox-line {
    pointer-events: none;
  }
</style>
